import { render, staticRenderFns } from "./AutomationsMainRow.vue?vue&type=template&id=c4ab86b4&scoped=true&"
import script from "./AutomationsMainRow.vue?vue&type=script&lang=js&"
export * from "./AutomationsMainRow.vue?vue&type=script&lang=js&"
import style0 from "./AutomationsMainRow.vue?vue&type=style&index=0&id=c4ab86b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ab86b4",
  null
  
)

export default component.exports